type SettingsTitleProps = {
  title: string
}

const SettingsTitle = ({ title }: SettingsTitleProps) => {
  return <h1 className="text-[32px] font-semibold leading-tight tracking-[-0.32px] text-primary">{title}</h1>
}

export default SettingsTitle
